<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/cylinders/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import {router} from "@inertiajs/vue3";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['cylinder_id'],
  data() {
    return {
      formRoute: route('api.v1.cylinders.update', {cylinder: this.cylinder_id}),
      redirectRoute: route('cylinders.index'),
      addNew: false
    }
  },
  methods: {
    afterSuccess(form, response) {
      if (this.addNew) {
        router.get(route('cylinders.create', {'success': 'Ok'}));
        return;
      }

      this.getCylinder();
    },

    getCylinder() {
      this.loading = true;

      $.ajax({
        url: route('api.v1.cylinders.show', {'cylinder': this.cylinder_id}),
        success: (response) => {
          this.$refs.form.setCylinder(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getCylinder();
  }
}
</script>

<template>
  <App title="Cilinder bewerken">
    <form id="cylinderForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="cylinderForm"
          :cancel-route="redirectRoute"
      >
        <button @click="addNew = true" form="cylinderForm" :class="{'btn btn-primary': true, 'loading' : loading}" :disabled="loading">
          Opslaan en nieuwe toevoegen
        </button>
      </FormButtons>
    </template>
  </App>
</template>